<form [formGroup]="form" class="container-fluid container-filter" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Comunidades Autónomas</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="Descripcion">Descripción</label>
                                    <input formControlName="Descripcion" name="Descripcion" maxlength="50" title=""
                                           class="form-control" id="Descripcion" type="text">
                                </div>
                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="Email">Email</label>
                                    <input formControlName="Email" name="Email" title="" maxlength="300"
                                           class="form-control" id="Email" type="email">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">
                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit"
                                                title="Realiza una búsqueda" (click)="onSearch($event)">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>
                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros"
                                                (click)="resetForm($event)">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
